import { useState } from "react";

export default function Login(){

  const [email,setEmail]=useState("");
  const [password,setPassword]=useState("");
  const [error,setError]=useState("");

  async function handleLogin(){

    const res = await fetch("/api/auth/login",{
      method:"POST",
      headers:{ "Content-Type":"application/json" },
      body:JSON.stringify({ email, password })
    });

    if(!res.ok){
      setError("Wrong email or password");
      return;
    }

    const data = await res.json();

    localStorage.setItem("accessToken", data.accessToken);
    localStorage.setItem("refreshToken", data.refreshToken);

    window.location.reload();
  }

  return(
    <div style={wrapper}>
      <div style={box}>
        <h2>Tradeon Login</h2>

        <input
          placeholder="Email"
          onChange={e=>setEmail(e.target.value)}
        />

        <input
          type="password"
          placeholder="Password"
          onChange={e=>setPassword(e.target.value)}
        />

        <button onClick={handleLogin}>Login</button>

        <div style={{color:"red",marginTop:10}}>
          {error}
        </div>
      </div>
    </div>
  );
}

const wrapper={
  height:"100vh",
  display:"flex",
  alignItems:"center",
  justifyContent:"center",
  background:"#0b1220",
  color:"white"
};

const box={
  background:"#111827",
  padding:40,
  borderRadius:12,
  width:320,
  display:"flex",
  flexDirection:"column",
  gap:10
};